<template>
  <div class="tw-relative tw-flex tw-flex-col">
    <label :for="label"></label>
    <input
      :type="type"
      class="tw-text-sm tw-rounded-lg tw-text-center tw-w-10 tw-h-10 sm:tw-h-12 sm:tw-w-12 tw-mb-6 tw-border-[#00258A] focus:tw-border-primary"
      :class="{
        'tw-border-error': showError === true,
      }"
      :id="position"
      v-model="value"
      @input="handleInput($event)"
      @keypress="isNumber($event)"
      @paste="handlePaste($event)"
      maxlength="1"
      minlength="1"
      placeholder="0"
      :disabled="disabled"
      required
    />
  </div>
</template>

<script>
import { isNumber } from "@/utils/helpers.js";
import { mapActions } from "vuex";
export default {
  name: "OnboardingCodeInput",
  emits: ["input", "handlePaste"],
  props: {
    label: { type: String, default: () => "", required: true },
    type: { type: String, default: () => "", required: true },
    digit: { type: [String, Number], required: true },
    error: { type: Object, default: () => {}, required: true },
    position: { type: Number, default: () => 0, required: true },
    disabled: { type: Boolean, default: () => false },
    pasted: {},
  },
  data() {
    return {
      showError: false,
      errorMsg: "",
      value: "",
    };
  },
  computed: {
    sameAsValue() {
      return this.digit === this.value;
    },
  },
  methods: {
    ...mapActions(["showToast"]),
    isNumber,
    handleInput(event) {
      const digitAsString = String(event.srcElement.value);
      const digitLength = digitAsString.length;
      const isDoubleDigit = digitLength > 1;
      const digit = isDoubleDigit
        ? digitAsString[digitLength - 1]
        : event.srcElement.value;
      this.$emit("input", { event, digit, position: this.position });
      this.value = digit;
    },
    handlePaste(event) {
      event.preventDefault();
      const paste = event.clipboardData.getData("text");
      if (isNaN(paste)) {
        this.showToast({
          description: "Only Numbers are supported",
          display: true,
          type: "error",
        });
      } else {
        this.$emit("handlePaste", paste);
      }
    },
    checkError() {
      if (this.error.$property !== this.position) {
        this.showError = false;
        this.errorMsg = "";
        return;
      }
      switch (this.error.$property) {
        case "firstDigit":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;
        case "secondDigit":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;
        case "thirdDigit":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;
        case "forthDigit":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;
        case "fifthDigit":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;
        case "sixthDigit":
          this.showError = true;
          this.errorMsg = this.error.$message;
          break;
        default:
          this.showError = false;
          this.errorMsg = "";
          break;
      }
    },
  },
  watch: {
    error(newValue, oldValue) {
      if (newValue !== oldValue) {
        this.checkError();
      }
    },
    digit(val) {
      if (val !== this.value) {
        this.value = val;
      }
    },
  },
};
</script>

<style lang="scss" scoped>
input::-webkit-outer-spin-button,
input::-webkit-inner-spin-button {
  -webkit-appearance: none;
  margin: 0;
}
/* Firefox */
input[type="number"] {
  -moz-appearance: textfield;
}
</style>
